"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortViewRendererComponents = sortViewRendererComponents;
exports.resolveViewRendererComponentSlot = resolveViewRendererComponentSlot;
exports.bucketViewRendererComponents = bucketViewRendererComponents;
exports.resolveViewRendererLayout = resolveViewRendererLayout;
const view_config_to_doc_page_1 = require("./view-config-to-doc-page");
function createEmptySlotBuckets() {
    return {
        header: [],
        sidebar: [],
        main: [],
        footer: [],
    };
}
function sortViewRendererComponents(components) {
    return [...components].sort((a, b) => a.position.y - b.position.y || a.position.x - b.position.x);
}
function resolveViewRendererComponentSlot(component, pageShape) {
    // Page chrome has one canonical render position. Older Landing App
    // instances persisted the footer as `main`; normalize at the shared layout
    // boundary so preview and published routes repair identically.
    if (component.componentType === 'app-base-footer') {
        return (0, view_config_to_doc_page_1.routeComponentToSlot)(component.componentType, pageShape);
    }
    return (component.slotKey ??
        (0, view_config_to_doc_page_1.routeComponentToSlot)(component.componentType, pageShape));
}
function bucketViewRendererComponents(components, pageShape) {
    const slots = createEmptySlotBuckets();
    for (const component of components) {
        slots[resolveViewRendererComponentSlot(component, pageShape)].push(component);
    }
    return slots;
}
function resolveViewRendererLayout(components, rawPageShape) {
    const pageShape = (0, view_config_to_doc_page_1.parsePageShape)(rawPageShape) ?? 'header';
    const componentSlots = bucketViewRendererComponents(sortViewRendererComponents(components), pageShape);
    const effectiveShape = (pageShape === 'sidebar' && componentSlots.sidebar.length === 0) ||
        (pageShape === 'fullwidth' && componentSlots.header.length > 0)
        ? 'header'
        : pageShape;
    return {
        pageShape,
        effectiveShape,
        componentSlots,
        layoutContract: (0, view_config_to_doc_page_1.getPageShapeLayoutContract)(effectiveShape),
    };
}
